import React from "react";
import TransactionLog from "./TransactionLog";
export default function SaleLogs() { return <TransactionLog kind="sale" />; }
